<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="d-flex min-vh-100 bg-cover" :style="'background-position: bottom;background-image: url('+require('@/assets/img/bg-hero.jpg')+');'">
            <div class="position-absolute w-100 min-vh-100 inset-0" style="z-index:1;backdrop-filter: blur(4px); background-color: rgba(0, 0, 0, .4);"></div>
            <div class="content container position-relative text-center h-100 d-flex flex-row align-items-center justify-content-center" style="z-index: 2;">
                <div class="p-5 bg-white rounded-xl" style="min-width: 33%;">
                    <h1><b>Félicitations!</b></h1>
                    <h4>Vous pouvez utiliser un coupon de</h4>
                    <h2>-8%</h2>
                    <h4>Voici votre code.</h4>
                    <span class="btn btn-rounded btn-primary text-dark" @click="copyText()">{{ couponCode }}</span>
                    <span class="text-xs d-block" v-if="!copied">Cliquez pour copier.</span>
                    <span class="text-xs d-block" v-if="copied">Copié</span>
                </div>
            </div>            
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style>
</style>
<script>
import router from '@/router';
import voucherManager from "@/utils/voucher";

export default {
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
    data() {
        return {
            couponCode: '',
            copied: false
        };
    },
    async created() {
        const voucher = await voucherManager.generateVoucher("/vouchers/generate/8-percent");
        this.couponCode = voucher.code;
        const redirectTo = (this.isLoggedIn) ? '/search' : '/login'
        setTimeout(() => {
            window.location.href = redirectTo
            // router.push(redirectTo)
        }, 3000); // 3 seconds
    },
    methods: {
        async copyText() {
            try {
                await navigator.clipboard.writeText(this.couponCode);
                this.copied = true;
                // Optional: Reset the "copied" status after a few seconds
                setTimeout(() => {
                    this.copied = false;
                }, 10000); // 3 seconds
            } catch (err) {
                console.error('Failed to copy text: ', err);
            }
        }
    }
}
</script>